// import components
import { Icon } from '@sdb/planning-ui';
import {
  StyledLinkIcon,
  StyledSummaryCardIconContainer
} from '../SummaryCard.styles';

// import hooks
import { useTranslation } from 'react-i18next';

// import stores
import { useCalendarStore } from 'components/mrp/stores/calendarStore/calendarStore';
import { useShallow } from 'zustand/shallow';

// import types
import { PlanningEntityIdentifier } from 'generated/index';

const OpenCalendarIcon = ({ entity, isPinned = true }) => {
  const { t } = useTranslation('common', { keyPrefix: 'mrp' });

  const { openCalendar } = useCalendarStore(
    useShallow((state) => ({
      openCalendar: state.control.openCalendar
    }))
  );

  const onOpenCalendar = (
    planningEntityIdentifier: PlanningEntityIdentifier,
    label: string
  ) => {
    openCalendar(
      [
        {
          label,
          planningEntityIdentifier
        }
      ],
      isPinned
    );
  };

  return (
    <StyledLinkIcon
      onClick={(e) => {
        e.stopPropagation();
        onOpenCalendar(entity.planningEntityIdentifier, entity.label);
      }}
      title={t('viewCalendar')}
    >
      <StyledSummaryCardIconContainer>
        <Icon type="calendar-plus" />
      </StyledSummaryCardIconContainer>
    </StyledLinkIcon>
  );
};

export default OpenCalendarIcon;
